export enum UnifiedRolesEditorPolicyResolverEnum {
  DEFAULT_POLICY = 'DEFAULT_POLICY',
}

export enum TenantSpecificTenantAdminRolesEnum {
  WITH_TENANT_SPECIFIC_TENANT_ADMIN_ROLES = 'WITH_TENANT_SPECIFIC_TENANT_ADMIN_ROLES',
  WITH_NON_TENANT_ADMIN_ROLES = 'WITH_NON_TENANT_ADMIN_ROLES',
}
